import { makeObservable, observable, flow, action, computed, toJS } from "mobx";
import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";
import { toast } from "sonner";

import CreateAuditSchema from "@/areas/compliance/schemas/CreateAuditSchema";
import SelectedAuditRegistryStore from "@/areas/settings/stores/SelectedAuditRegistryStore";

export default class CreateAuditStore {
  visible = false;
  auditRegistries = [];

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      auditRegistries: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      load: flow,
      canCreate: computed,
    });

    this.parentStore = parentStore;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  get canCreate() {
    return this.auditRegistries.length > 0;
  }

  *load() {
    this.auditRegistries = [];

    const browseAuditRegistriesStore = this.parentStore.parentStore.settingsStore.browseAuditRegistriesStore;
    const response = yield browseAuditRegistriesStore.load({ search: "", page: 1 });

    if (!response.success) {
      return;
    }

    const registries = browseAuditRegistriesStore.registries;

    if (registries.length === 0) {
      return;
    }

    const settingsStore = this.parentStore.parentStore.settingsStore;

    this.auditRegistries = (yield Promise.all(
      registries.map(async (rowItem) => {
        const selectedStore = new SelectedAuditRegistryStore(settingsStore, rowItem.id, rowItem);

        // TODO: HIGH should this be yeilded?
        await selectedStore.subscriberSummaryStore.load({});

        return selectedStore.auditRegistryPermissionStore.isCoordinator ? rowItem : null;
      })
    )).filter((item) => item !== null);
  }

  *save(data, options) {
    const parseResult = CreateAuditSchema.safeParse(data);
    if (!parseResult.success) {
      toast.error(parseResult.error);
      return parseResult;
    }

    try {
      const { period, ...payload } = parseResult.data;
      const response = yield api.post(ApiRoutes.forAudits(), {
        ...payload,
        periodStartAt: period.from,
        periodEndAt: period.to,
      });
      this.visible = false;
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    }
  }
}
